import React, { useRef, useState, useEffect } from "react";
import { Box, Grid, Typography, Button, Divider } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { changePassword, newPassword } from "../../services/user.service";
import { encryptData } from "../../utils/cryptoUtils";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import { isAdminRole } from "../../utils/roles";

const ChangePassword = (props) => {
  const { setOpenDrawer, formType, selectedData } = props;
  const disabled = formType === "view";
  const { accessToken } = useAuth();
  const formRef = useRef(null);

  const [initialValues, setInitialValues] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [isAdminReset, setIsAdminReset] = useState(false);

  useEffect(() => {
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        // Check if current user is admin (role 1 or 4) AND they are editing someone else's profile
        // Or if the selectedData ID is different from the logged in user's ID
        const isUserAdmin = isAdminRole(decoded.role);
        const isEditingOther = selectedData && selectedData._id !== decoded.id; // Assuming selectedData has _id

        if (isUserAdmin && isEditingOther) {
          setIsAdminReset(true);
        } else {
          setIsAdminReset(false);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [accessToken, selectedData]);

  const validationSchema = Yup.object().shape({
    oldPassword: isAdminReset
      ? Yup.string() // Not required for admin reset
      : Yup.string().required("Old Password is required"),
    newPassword: Yup.string()
      .required("New Password is required")
      .notOneOf(
        [Yup.ref("oldPassword")],
        "The new password does not match the old password."
      ),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  //decodeToken
  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  useEffect(() => {
    // GetProjectData();
    if (formType === "edit" || formType === "view") {
      // setInitialValues({
      //   oldPassword: selectedData.oldPassword || "",
      //   newPassword: selectedData.newPassword || "",
      // });
    }
  }, [formType, selectedData]);
  const onSubmit = async (values) => {
    try {
      if (isAdminReset) {
        const payload = {
          newPassword: encryptData(values.newPassword),
        }
        const apiMethod = newPassword(selectedData._id, payload);
        const res = await apiMethod;
        ToastSuccess(res?.message || "Password updated successfully");
      } else {
        const userId = getUserIdFromToken();
        const apiMethod = changePassword(userId, { ...values });
        const res = await apiMethod;
        ToastSuccess(res?.data?.message);
      }
      setOpenDrawer(false);
    } catch (error) {
      ToastError(error?.data?.message || "Error updating password");
    }
  };
  return (
    <div className="addRenderingPopup">
      <Box className="addContainerHeader">
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          {/* {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "} */}
          Change Password
        </Typography>
        <CloseIcon
          className="Close-Icon"
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                {!isAdminReset && (
                  <Grid item xs={12} sm={12}>
                    <Typography className="inputLabel">
                      Old Password <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Field
                      name="oldPassword"
                      className="InputField w-100"
                      placeholder="Enter Old Password"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.oldPassword &&
                        errors.oldPassword &&
                        errors.oldPassword}
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} sm={12}>
                  <Typography className="inputLabel">
                    New Password <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Field
                    name="newPassword"
                    className="InputField w-100"
                    placeholder="Enter New Password"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.newPassword &&
                      errors.newPassword &&
                      errors.newPassword}
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography className="inputLabel">
                    Confirm Password
                  </Typography>
                  <Field
                    name="confirmPassword"
                    className="InputField w-100"
                    placeholder="Enter New Password"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.confirmPassword &&
                      errors.confirmPassword &&
                      errors.confirmPassword}
                  </div>
                </Grid>
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ChangePassword;
